import '../assets/styles/App.css';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../components/Header';
import { getCookie, setCookie } from '../cookie/cookies';

import Footer from '../components/Footer';

const isMobile = /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);

function Product({}) {
    const [loading, setLoading] = useState(false);
    // get device width
    const [width, setWidth] = useState(window.innerWidth);
    const data = require('../assets/data/data.json');
    const [item, setItem] = useState({
        id: '',
        name: '',
        price: '',
        description: '',
    });
    const { product } = useParams();
    const [alpha, setAlpha] = useState('');
    const [beta, setBeta] = useState('');
    const [theta, setTheta] = useState('');
    const [gamma, setGamma] = useState('');
    const [quantity, setQuantity] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const { naver } = window;

    useEffect(() => {
        for (let i = 0; i < data.products.length; i++) {
            if (data.products[i].id == product) {
                setItem(data.products[i]);
            }
        }

        // get cookie of the browser named NA_CO
        let NA_CO = getCookie('NA_CO');
    }, [product]);

    useEffect(() => {
        // document.getElementById('naverpay-button').innerHTML = '';
        // naverPayButton();
    }, [item, alpha, beta, theta, gamma]);

    let navigate = useNavigate();

    const routeChange = (isInternal, path, e) => {
        e.preventDefault();
        if (isInternal) {
            let newPath = path;
            navigate(newPath);
        } else {
            window.open(path);
        }
    };

    const onChangeAlpha = (e) => {
        // validate alpha to be between 0 and 100
        if (e.target.value > 100) {
            setAlpha(100);
        } else if (e.target.value < 0) {
            setAlpha(0);
        } else {
            setAlpha(e.target.value);
        }
    };

    const onChangeBeta = (e) => {
        // validate beta to be between 0 and 100

        if (e.target.value > 100) {
            setBeta(100);
        } else if (e.target.value < 0) {
            setBeta(0);
        } else {
            setBeta(e.target.value);
        }
    };

    const onChangeTheta = (e) => {
        // validate theta to be between 0 and 100

        if (e.target.value > 100) {
            setTheta(100);
        } else if (e.target.value < 0) {
            setTheta(0);
        } else {
            setTheta(e.target.value);
        }
    };

    const onChangeGamma = (e) => {
        // validate gamma to be betwen 0 and 100

        if (e.target.value > 100) {
            setGamma(100);
        } else if (e.target.value < 0) {
            setGamma(0);
        } else {
            setGamma(e.target.value);
        }
    };

    const changeShowModal = (e) => {
        e.preventDefault();
        if (alpha === '' || beta === '' || theta === '' || gamma === '') {
            alert('뇌파 값을 모두 입력해주세요.');
            return;
        }
        setShowModal(!showModal);
    };

    const increaseQuantity = (e) => {
        e.preventDefault();
        setQuantity(quantity + 1);
    };

    const decreaseQuantity = (e) => {
        e.preventDefault();
        if (quantity > 1) {
            setQuantity(quantity - 1);
        }
    };

    const saveToCart = (e) => {
        let cartItem = {
            id: item.id,
            name: item.name,
            value: `${alpha},${beta},${theta},${gamma}`,
            quantity: quantity,
            itemPrice: item.price,
            totalPrice: (parseInt(item.price) * quantity).toString(),
        };

        // get cart from cookie
        let cart = getCookie('cart');
        if (cart === '' || cart === undefined) {
            cart = [];
        }

        cart.push(cartItem);

        setCookie('cart', cart);

        setShowModal(false);
    };

    const purchase = (e) => {
        saveToCart();
        navigate('/cart');
    };

    const purchaseNaver = () => {
        // TODO: 로딩 화면 추가
        if (alpha === '' || beta === '' || theta === '' || gamma === '') {
            alert('뇌파 값을 모두 입력해주세요.');
            return;
        } else {
            setLoading(true);
            console.log(getCookie('NA_CO'));
            let selectedItems = {
                id: item.id,
                name: item.name,
                value: `${alpha},${beta},${theta},${gamma}`,
                quantity: quantity,
                itemPrice: item.price,
                totalPrice: (parseInt(item.price) * quantity).toString(),
            };
            let url = `${process.env.REACT_APP_API_URL}/getOrderIdFromNaver`;
            let data = {
                items: [selectedItems],
                NA_CO: getCookie('NA_CO'),
                backURL: isMobile
                    ? `https://rd2.randomdiversity.com/lab/${item.id}`
                    : `https://rd2pc.randomdiversity.com/lab/${item.id}`,
            };

            axios
                .post(url, data)
                .then((res) => {
                    setLoading(false);
                    console.log(res.data.queryString);
                    let url = `https://pay.naver.com/customer/order.nhn?${res.data.queryString}&ORDER_ID=${res.data.orderId}`;
                    if (isMobile) {
                        window.location.href = url;
                    } else {
                        // open the url in another window
                        window.open(url);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };

    const wishlist = () => {
        const SHOP_ID = encodeURI('np_flkib849092');
        setLoading(true);
        let url = `${process.env.REACT_APP_API_URL}/addZzimListToNaver`;

        let data = null;

        if (isMobile) {
            data = {
                item: {
                    id: item.id,
                    name: item.name,
                    value: `${alpha},${beta},${theta},${gamma}`,
                    quantity: quantity,
                    itemPrice: item.price,
                    totalPrice: (parseInt(item.price) * quantity).toString(),
                    isPc: false,
                },
            };
        } else {
            data = {
                item: {
                    id: item.id,
                    name: item.name,
                    value: `${alpha},${beta},${theta},${gamma}`,
                    quantity: quantity,
                    itemPrice: item.price,
                    totalPrice: (parseInt(item.price) * quantity).toString(),
                    isPc: true,
                },
            };
        }

        axios
            .post(url, data)
            .then((res) => {
                setLoading(false);
                if (isMobile) {
                    let url = `https://m.pay.naver.com/mobile/customer/wishList.nhn?ITEM_ID=${res.data.itemId}&SHOP_ID=${SHOP_ID}`;
                    window.location.href = url;
                } else {
                    let url = `https://pay.naver.com/customer/wishlistPopup.nhn?ITEM_ID=${res.data.itemId}&SHOP_ID=${SHOP_ID}`;
                    // open the url in popup
                    window.open(url, 'naverWishlist', 'width=600,height=600');
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const naverPayButton = () => {
        // use ref to apply button

        if (isMobile) {
            const buttonMobile = naver.NaverPayButton.apply({
                BUTTON_KEY: 'E9B87F48-E8F0-4A20-9D03-2CDCACDE0DB4', // 네이버페이에서 제공받은 “버튼 인증 키” 입력.
                TYPE: 'MA', // 버튼 모음 종류 설정. 모바일은 MA, MB 2가지만 사용.
                COLOR: 1, // 버튼 모음의 색 설정.
                COUNT: 2, // 쇼핑몰 상품상세(COUNT:2 사용), 장바구니(COUNT:1 사용) 페이지.
                ENABLE: 'N', // 품절 등의 이유로 버튼 모음을 비활성화할 때에는 "N" 입력
                BUY_BUTTON_HANDLER: purchaseNaver, // 구매하기 버튼 이벤트 Handler 함수 등록, 품절인 경우 not_buy_nc 함수 사용
                //BUY_BUTTON_LINK_URL:“naverpay_order.php", // 링크 주소 (필요한 경우만 사용)
                WISHLIST_BUTTON_HANDLER: wishlist, // 찜하기 버튼 이벤트 Handler 함수 등록
                //WISHLIST_BUTTON_LINK_URL:“zzim.php", // 찜하기 팝업 링크 주소 (필요한 경우만 사용)
                EMBED_ID: 'naverpay-button', // 장바구니 페이지에 삽입할 DIV의 ID
                '': '',
            });
        } else {
            const buttonPC = naver.NaverPayButton.apply({
                BUTTON_KEY: 'E9B87F48-E8F0-4A20-9D03-2CDCACDE0DB4', // 네이버페이에서 제공받은 “버튼 인증 키” 입력.
                TYPE: 'C', // 버튼 모음 종류 설정. 모바일은 MA, MB 2가지만 사용.
                COLOR: 1, // 버튼 모음의 색 설정.
                COUNT: 2, // 쇼핑몰 상품상세(COUNT:2 사용), 장바구니(COUNT:1 사용) 페이지.
                ENABLE: 'N', // 품절 등의 이유로 버튼 모음을 비활성화할 때에는 "N" 입력
                BUY_BUTTON_HANDLER: purchaseNaver, // 구매하기 버튼 이벤트 Handler 함수 등록, 품절인 경우 not_buy_nc 함수 사용
                //BUY_BUTTON_LINK_URL:“naverpay_order.php", // 링크 주소 (필요한 경우만 사용)
                WISHLIST_BUTTON_HANDLER: wishlist, // 찜하기 버튼 이벤트 Handler 함수 등록
                //WISHLIST_BUTTON_LINK_URL:“zzim.php", // 찜하기 팝업 링크 주소 (필요한 경우만 사용)
                EMBED_ID: 'naverpay-button', // 장바구니 페이지에 삽입할 DIV의 ID
                '': '',
            });
        }
    };

    const Modal = () => {
        return (
            <div className='modal-background'>
                <div className='modal'>
                    <div className='modal-content'>
                        <div className='quantity'>
                            <div
                                onClick={(e) => decreaseQuantity(e)}
                                style={{ width: `${(width - 32) * 0.1}px` }}
                                className='quantity-button'
                            >
                                -
                            </div>
                            <div
                                style={{ width: `${(width - 32) * 0.8}px` }}
                                className='quantity-value'
                            >
                                {quantity}
                            </div>
                            <div
                                onClick={(e) => increaseQuantity(e)}
                                style={{ width: `${(width - 32) * 0.1}px` }}
                                className='quantity-button'
                            >
                                +
                            </div>
                        </div>
                        <div className='modal-buttons'>
                            <div
                                onClick={(e) => saveToCart(e)}
                                className='order-button cart-button'
                            >
                                장바구니 담기
                            </div>
                            <div
                                // onClick={(e) => purchase(e)}
                                className='order-button cart-button'
                                style={{
                                    backgroundColor: '#000',
                                    color: '#fff',
                                }}
                            >
                                품절
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className='App'>
            {item.name !== '' ? (
                <>
                    <Header header={item.name} />
                    <div>
                        <img
                            className='product-image'
                            src={require(`../assets/images/${item.id}.png`)}
                        />
                        <div className='product-detail'>
                            <div className='product-name'>{item.name}</div>
                            <div className='product-price'>
                                {' '}
                                ₩{item.price.slice(0, -3)},
                                {item.price.slice(-3)}
                            </div>
                            <div className='product-description'>
                                {item.description}
                            </div>
                        </div>
                        <div className='wave-input-container'>
                            <div className='wave-input'>
                                &alpha;
                                <input
                                    value={alpha}
                                    onChange={(e) => onChangeAlpha(e)}
                                    type='number'
                                />
                            </div>
                            <div className='wave-input'>
                                &beta;
                                <input
                                    value={beta}
                                    onChange={(e) => onChangeBeta(e)}
                                    type='number'
                                />
                            </div>
                            <div className='wave-input'>
                                &theta;
                                <input
                                    value={theta}
                                    onChange={(e) => onChangeTheta(e)}
                                    type='number'
                                />
                            </div>
                            <div className='wave-input'>
                                &gamma;
                                <input
                                    value={gamma}
                                    onChange={(e) => onChangeGamma(e)}
                                    type='number'
                                />
                            </div>
                        </div>

                        <div style={{ padding: '0 28px' }}>
                            <button
                                // onClick={(e) => changeShowModal(e)}
                                className='order-button'
                                style={{
                                    backgroundColor: '#000',
                                    color: '#fff',
                                }}
                            >
                                품절
                            </button>
                        </div>
                    </div>
                </>
            ) : null}
            {showModal ? <Modal /> : null}
            {/* <div style={{ margin: '28px 28px' }} id='naverpay-button'></div> */}
            <Footer />
        </div>
    );
}

export default Product;
